import React from 'react';
import { Route } from 'react-router-dom';
import BorrowingLayout from 'app/components/borrowing/shared/BorrowingLayout';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import CheckedOutPageRoute from './CheckedOutPageRoute';

const basePath = '/v2/checkedout';

export default (
  <Route path={`${basePath}/:status?`}>
    <AuthenticatedRoute>
      <AccountRequiredRoute>
        <BorrowingLayout>
          <CheckedOutPageRoute />
        </BorrowingLayout>
      </AccountRequiredRoute>
    </AuthenticatedRoute>
  </Route>
);
